export const getExperiments = () =>
	window.escapioExperimentVersions
		? Object.keys(window.escapioExperimentVersions)
		: [];
export const getExperimentVersionsAsJSONString = () =>
	window.escapioExperimentVersions
		? JSON.stringify(window.escapioExperimentVersions)
		: "";

export const getExperimentVersion = experimentName =>
	(window.escapioExperimentVersions &&
		window.escapioExperimentVersions[experimentName]) ||
	undefined;

export const isFirstVisit = experimentName =>
	Boolean(window.escapioExperimentsFirstVisits[experimentName]);
